import { mainSiteUrl } from '@/mocks/categories';
import { trustBadges } from '@/mocks/seo-content';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20abstract%20retail%20shopping%20lifestyle%20composition%20with%20floating%20fashion%20items%20gently%20scattered%2C%20warm%20amber%20and%20cream%20gradient%20background%2C%20minimal%20aesthetic%2C%20subtle%20fabric%20textures%2C%20elegant%20product%20photography%20style%2C%20soft%20diffused%20lighting%2C%20no%20text%2C%20dreamy%20editorial%20atmosphere&width=1600&height=900&seq=sugargoo-hero-v2&orientation=landscape"
          alt="Sugargoo Spreadsheet curated shopping database lifestyle"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-20">
        <span className="inline-block px-4 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/30 text-background-50 text-xs font-medium mb-6">
          Updated 2026 Database
        </span>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-6">
          The Ultimate Sugargoo<br className="hidden sm:block" /> Spreadsheet Database
        </h1>

        <p className="text-base md:text-lg text-background-100/90 max-w-2xl mx-auto mb-8 leading-relaxed">
          Discover thousands of updated Sugargoo Spreadsheet products, shopping guides, price comparisons, and expert resources to find better products faster.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-10">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-base transition-all cursor-pointer whitespace-nowrap"
          >
            Sugargoo Spreadsheet
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-background-50 hover:bg-background-100 text-foreground-900 font-semibold text-base transition-all cursor-pointer whitespace-nowrap"
          >
            Buy It Now
            <i className="ri-shopping-bag-line ml-2"></i>
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-3 md:gap-4">
          {trustBadges.map((badge) => (
            <span key={badge} className="flex items-center gap-1.5 text-background-50/80 text-xs md:text-sm">
              <i className="ri-check-line text-accent-400 text-sm"></i>
              {badge}
            </span>
          ))}
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-background-50/60 text-2xl"></i>
      </div>
    </section>
  );
}